import { useForm } from '@mantine/form';
import {
  Button,
  Group,
  Checkbox,
  TextInput,
  Stack,
  Modal,
} from '@mantine/core';
import type { Partner, SupportStoreType } from '../../../models/partner.ts';

export interface UpdatePartnerForm {
  displayNameForHuman?: string;
  supportStoreTypes: SupportStoreType[];
}

interface UpdatePartnerModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: ({ formValues }: { formValues: UpdatePartnerForm }) => void;
  partner: Partner;
  isPending: boolean;
}

export default function UpdatePartnerModal({
  opened,
  onClose,
  onConfirm,
  partner,
  isPending,
}: UpdatePartnerModalProps) {
  const form = useForm<UpdatePartnerForm>({
    mode: 'uncontrolled',
    initialValues: {
      displayNameForHuman: partner.displayNameForHuman,
      supportStoreTypes: partner.supportStoreTypes,
    },
    validate: {
      supportStoreTypes: (value) =>
        value.length > 0 ? null : '請選擇可管理場站類型',
    },
  });

  const checkBoxStyle = form.errors.supportStoreTypes
    ? {
        input: { borderColor: 'var(--mantine-color-red-6)' },
        label: { color: 'var(--mantine-color-red-6)' },
      }
    : undefined;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="編輯業者"
      centered
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <Stack>
        <form
          onSubmit={form.onSubmit((values: UpdatePartnerForm) =>
            onConfirm({ formValues: values }),
          )}
        >
          <TextInput
            withAsterisk
            label="業者名稱"
            readOnly
            value={partner.name}
            styles={{
              input: {
                backgroundColor: '#E9ECEF',
                color: 'gray',
                cursor: 'default',
              },
            }}
          ></TextInput>
          <TextInput
            mt="md"
            label="前台顯示名稱"
            placeholder="請輸入前台顯示名稱"
            key={form.key('displayNameForHuman')}
            {...form.getInputProps('displayNameForHuman')}
          />
          <Checkbox.Group
            mt="md"
            withAsterisk
            label="可管理場站類型"
            {...form.getInputProps('supportStoreTypes')}
            styles={{
              error: { marginTop: 10 },
            }}
          >
            <Group>
              <Checkbox
                value="Parkinglot"
                label="停車場"
                styles={checkBoxStyle}
              />
              <Checkbox
                value="GasStation"
                label="加油站"
                styles={checkBoxStyle}
              />
              <Checkbox
                value="ChainStore"
                label="連鎖店"
                styles={checkBoxStyle}
              />
            </Group>
          </Checkbox.Group>
          <Group justify="flex-end" mt="md">
            <Button type="button" onClick={onClose} variant="outline" fw={400}>
              取消
            </Button>
            <Button type="submit" loading={isPending} fw={400}>
              更新
            </Button>
          </Group>
        </form>
      </Stack>
    </Modal>
  );
}
